<mat-list>
  @for (main of list; track $index) {
      <div style="margin: 0 0 20px;">
          @if (main.action) {
              <div mat-subheader matRipple style="margin: 0; padding: 10px 17px;" class="main pointer-cursor" [class.selected]="layoutService.selectedAction === main.action" (click)="clickList($event, main.action)">{{ main.header }}</div>
          }
          @else {
              <div mat-subheader style="margin: 0; padding: 10px 17px;">{{ main.header }}</div>
          }
          @if (main.menu) {
              @for (sub of main.menu; track $index) {
                  <mat-list-item matRipple (click)="clickList($event, sub.action)">
                      <mat-icon matListItemIcon class="sub pointer-cursor" [class.selected]="layoutService.selectedAction === sub.action">{{ sub.icon }}</mat-icon>
                      <div matListItemTitle class="sub pointer-cursor" [class.selected]="layoutService.selectedAction === sub.action">{{ sub.name }}</div>
                  </mat-list-item>
              }
          }
      </div>
  }
</mat-list>